<template>
    <div>
        <div class="form flex a-center j-between mt--23">
            <div class="form-left ml--30">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="类型名称:" prop="name" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.name" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="form-right mr--24 mb--22">
                <el-button class="search-button h--40 w--90 fs--14" icon="el-icon-search" type="primary" size="small"
                    @click="search">查询</el-button>
                <el-button @click="reset" icon="el-icon-refresh-right" class="reset-button h--40 w--90 fs--14"
                    size="small">重置</el-button>
            </div>
        </div>
        <div class="table-box ml--30 mt--23 mr--30">
            <el-table :data="tableData" border stripe style="width: 100%" :height="height">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="icon" label="图标">
                    <template slot-scope="scope">
                        <img :src="scope.row.icon" alt="" style="width: 40px;height: 40px;" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="类型"></el-table-column>
                <el-table-column prop="carNum" label="车辆数"></el-table-column>
            </el-table>
            <div class="relative mt--23 flex j-end">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-size="pageSize" background 
                    layout="total,sizes,prev, pager, next,jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getCarTypeList } from './service'
export default {
  data() {
    return {
      searchForm: {
        name: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  computed: {
    height() {
      return this.$baseTableHeight();
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const params = {
        name: this.searchForm.name,
        pageCurr: this.currentPage,
        pageSize: this.pageSize,
      };
      
      getCarTypeList(params).then(res => {
        if (res && res.records) {
          this.tableData = res.records;
          this.total = res.total;
        } else {
          // 如果返回的是完整数组而不是分页对象，直接使用
          this.tableData = res || [];
          this.total = (res || []).length;
        }
      });
    },
    showDetail() {
      this.$refs.detailModal.dialogVisible = true;
    },
    reset() {
      this.searchForm.name = '';
      this.currentPage = 1;
      this.getList();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
::v-deep .el-form-item .el-input__inner {
  width: 240px;
}
</style>